import { colors, allGroups } from './data.js';
import { addToCart } from './cart.js';
import { servObj } from './init_glob.js';
import { openModal } from './modals.js';

const formatNumber = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

let activeTilePattern = null;
let activeFacture = null;
let activeCollection = null;
let activeDepth = null;
let activeColor = null;
let activeGroupName = null;

let tilePrice = 0;

const count = servObj.currentCount;

servObj.tile = {
    activeTilePattern: {
        isDefault: true,
        name: 'Абрис',
        pathName: 'abris',
    },
    activeFacture: {
        isDefault: true,
        name: 'Гранит',
        pathName: 'granit',
        collections: {
            colormix: {
                isDefault: true,
                name: 'Колормикс',
                pathName: 'colormix',
                depth: {
                    60: {
                        isDefault: true,
                        default: 'husky',
                        colors: [
                            {
                                colorName: 'husky',
                                border: 'border_swivel_500x200x80_granit_white',
                            },
                            {
                                colorName: 'autumn',
                                border: 'border_sidewalk_1000x200x80_granit_autumn',
                            },
                            {
                                colorName: 'antracit',
                                border: 'border_sidewalk_1000x200x80_granit_antracit',
                            },
                        ],
                    },
                    isDefault: true,
                },
            },
            monocolor: {
                name: 'Моноцвет',
                pathName: 'monocolor',
                depth: {
                    60: {
                        isDefault: true,
                        default: 'gray',
                        colors: [
                            {
                                colorName: 'gray',
                                border: 'border_sidewalk_1000x200x80_gray',
                            },
                            {
                                colorName: 'white',
                                border: 'border_swivel_500x200x80_granit_white',
                            },
                            {
                                colorName: 'black',
                                border: 'border_swivel_500x200x80_granit_white',
                            },
                        ],
                    },
                },
            },
        },
    },
    activeCollection: {
        isDefault: true,
        name: 'Колормикс',
        pathName: 'colormix',
        depth: {
            60: {
                isDefault: true,
                default: 'husky',
                colors: [
                    {
                        colorName: 'husky',
                        border: 'border_swivel_500x200x80_granit_white',
                    },
                    {
                        colorName: 'autumn',
                        border: 'border_sidewalk_1000x200x80_granit_autumn',
                    },
                    {
                        colorName: 'antracit',
                        border: 'border_sidewalk_1000x200x80_granit_antracit',
                    },
                ],
            },
            isDefault: true,
        },
    },
    activeDepth: '60',
    activeColor: 'antracit',
    activeGroupName: 'abris',
    //"isEmptyTexture": false
}; // TODO set default
servObj.defaultTile = structuredClone(servObj.tile);

export const calculatePrice = () => {
    let priceByMeters = 0;

    if (window.price[activeFacture.name] && activeColor) {
        for (let key in colors) {
            if (key == activeColor) {
                const colorName = colors[key].name;
                const facture = window.price[activeFacture.name];
                const collection = facture[activeCollection.name];
                const priceByDepth = collection[colorName];

                for (let depth in priceByDepth) {
                    if (depth.includes(activeDepth)) {
                        priceByMeters = Number(priceByDepth[depth].trim().replace(' ', ''));
                    }
                }
            }
        }
    }
    const mps = document.querySelector('input[name="meters-per-square"]').value;
    tilePrice = priceByMeters * mps;

    document.querySelector('#price').innerHTML = `${formatNumber(priceByMeters)} руб.`;
    document.querySelector('#total-price').innerHTML = `${formatNumber(tilePrice)} руб.`;
    document.querySelector('#price__mps').innerHTML = `${formatNumber(mps)} м&sup2;`;

    return tilePrice;
};

let lastValidValue = '1';
document.querySelector('input[name="meters-per-square"]').addEventListener('input', function (e) {
    if (/^\d*$/.test(this.value)) {
        //lastValidValue = formatNumber(Number(this.value))
        lastValidValue = this.value;
        //console.log(formatNumber(Number(this.value)))
        count.setCount(Number(this.value));
        calculatePrice();
    } else {
        this.value = lastValidValue;
    }
});

document.querySelector('#add_to_cart').addEventListener('pointerdown', () => {
    console.log(activeGroupName);
    console.log(allGroups);
    addToCart(
        `Тротуарная плитка ${allGroups[activeGroupName].name}. Фактура: ${activeFacture.name}. Коллекция: ${activeCollection.name}. Толщина: ${activeDepth}мм. Цвет: ${colors[activeColor].name}.`,
        tilePrice,
        count.count,
        `./images/facades/${activeTilePattern.pathName}/${activeColor}.jpg`
    );
});

let innerHTML = `<div data-grid-cols="3" class="content">`;

for (let key in allGroups) {
    const group = allGroups[key];
    const image = allGroups[key].images[0];
    let imageName = image.pathName;

    // TODO: image src
    //console.log({key, imageName})
    innerHTML += `
		<div class="content__item">
			
			<label for="paving-slabs__${key}">
                <input value="paving-slabs__${key}" type="radio" name="paving-slabs" id="paving-slabs__${key}">
				<img src="./images/facades/${imageName}/default.jpg" alt="${imageName}" class="item__img"> 
				<p class="item__name">
					${group.name}
				</p>
			</label>
		</div>
	`;
}
innerHTML += '</div>';

document.querySelector('#collections-accordion').innerHTML = innerHTML;

document.querySelector('#option-tile-pattern .option__content').addEventListener('change', (e) => {
    // document.querySelectorAll('.info-window__img-block .info-window__img').forEach((el) => {
    //     el.classList[el.src.includes(e.target.value) ? 'add' : 'remove']('active');
    //     if (el.src.includes(e.target.value)) window.servObj.activeTilePatternName = e.target.value;
    // });

    allGroups[activeGroupName].images.map((img) => {
        if (img.pathName == e.target.value) servObj.tile.activeTilePattern = img;
    });

    document.querySelectorAll('.info-window__img-block .info-window__img').forEach((el) => {
        let color = '';
        const splited = el.src.split('/');
        if (splited[splited.length - 1]) color = splited[splited.length - 1].split('.')[0]; // TODO
        el.classList[color == servObj.tile.activeColor && el.src.includes(e.target.value) ? 'add' : 'remove']('active');
    });

    document.querySelectorAll('#option-color img').forEach((el) => {
        // console.log(e.target.value)
        // console.log(el.src)
        el.src.includes(e.target.value) ? (el.style.display = 'block') : (el.style.display = 'none');
    });

    let isHasActiveImage = false;
    document.querySelectorAll('.info-window__img-block .info-window__img').forEach((el) => {
        if (el.classList.contains('active')) isHasActiveImage = true;
    });
    if (!isHasActiveImage) {
        document.querySelector('.info-window img[src="./images/facades/undefined.jpg"]').classList.add('active');
    }

    // group.images.map(img => {
    //     path = `./images/facades/${img.pathName}/${colorName}/${colorName}.jpg`
    //     const activeImage = document.querySelector("#option-tile-pattern input:checked").value

    //     const style = path.includes(activeImage) ? "block" : "none"
    //     console.log({path, activeImage, style})
    //     return `<img src=${path} alt="Ёлочка" class="item__img color-item" style="display: ${style}"></img>`
    // }
});

document.querySelector('#facture').addEventListener('change', (e) => {
    activeTilePattern = servObj.tile.activeTilePattern;
    activeFacture = allGroups[activeGroupName].factures[e.target.value];
    activeCollection = null;
    activeDepth = null;
    activeColor = null;

    reCreateGroupMenu();
});

document.querySelector('#option-collection .option__list').addEventListener('change', (e) => {
    activeTilePattern = servObj.tile.activeTilePattern;
    activeCollection = activeFacture.collections[e.target.value];
    activeDepth = null;
    activeColor = null;
    reCreateGroupMenu();
});

document.querySelector('#option-depth .option__list').addEventListener('change', (e) => {
    activeDepth = e.target.value;
    activeColor = activeCollection.depth[activeDepth].default;
    reCreateGroupMenu();
});

document.querySelector('#option-color').addEventListener('change', (e) => {
    for (let key in colors) {
        if (key == e.target.value) activeColor = key;
    }

    //console.log({activeColor})
    servObj.tile.activeColor = activeColor;

    document.querySelectorAll('.info-window__img-block .info-window__img').forEach((el) => {
        let color = '';
        const splited = el.src.split('/');
        if (splited[splited.length - 1]) color = splited[splited.length - 1].split('.')[0]; // TODO

        el.classList[color == activeColor && el.src.includes(activeTilePattern.pathName) ? 'add' : 'remove']('active');
    });

    let isHasActiveImage = false;
    servObj.tile.isEmptyTexture = false;

    document.querySelectorAll('.info-window__img-block .info-window__img').forEach((el) => {
        if (el.classList.contains('active')) isHasActiveImage = true;
    });

    if (!isHasActiveImage) {
        servObj.tile.isEmptyTexture = true;
        document.querySelector('.info-window img[src="./images/facades/undefined.jpg"]').classList.add('active');
    }

    calculatePrice();
});
document.querySelector('#option-color').addEventListener('pointerup', () => openModal('confirm-apply-tile-modal'));

let createColorsMenuByPossibleColorsOnce = false;

const createColorsMenuByPossibleColors = (group, possibleColors) => {
    createColorsMenuByPossibleColorsOnce = true;
    let optionColorsInnerText = '';
    possibleColors.map((colorName) => {
        //console.log({colors})
        const color = colors[colorName];
        let path = '';
        let innerColorsHTML = '';

        group.images.map((img) => {
            path = `./images/facades/${img.pathName}/${colorName}.jpg`;
            const activeImage = document.querySelector('#option-tile-pattern input:checked').value; // TODO: set to servobj
            const style = path.includes(activeImage) ? 'block' : 'none';
            innerColorsHTML += `<img src=${path} alt="Ёлочка" class="item__img color-item" style="display: ${style}"/>`;
        });

        optionColorsInnerText += `
            <div class="content__item">
                <label> <input type="radio" name="paving-slabs__color" value="${colorName}" />
                    ${innerColorsHTML}
                    <p class="item__name">${color.name}</p>
                </label>
            </div>
        `;

        //     <div class="content__item ${!colorsByDepth.includes(colorName) ? 'disabled' : ''}">
        //     <label> <input type="radio" name="paving-slabs__color" value="${color.hex}" ${activeColor == colorName && 'checked'} />
        //         ${
        //             group.images.map(img => {
        //                 path = `./images/facades/${img.pathName}/${colorName}/${colorName}.jpg`
        //                 const activeImage = document.querySelector("#option-tile-pattern input:checked").value   // TODO: set to servobj

        //                 const style = path.includes(activeImage) ? "block" : "none"
        //                 return `<img src=${path} alt="Ёлочка" class="item__img color-item" style="display: ${style}"></img>`
        //             })
        //             }
        //         <p class="item__name">${color.name}</p>
        //     </label>
        // </div>
    });
    document.querySelector('#option-color .content').innerHTML = optionColorsInnerText;
};

const updateColorsMenu = (colorsByDepth, activeColor) => {
    document.querySelectorAll('#option-color .content__item').forEach((clrEl) => {
        const img = clrEl.querySelector('img');
        const input = clrEl.querySelector('input');
        const colorName = input.value;
        //console.log(colorsByDepth)
        //console.log(colorName)
        clrEl.classList[colorsByDepth.includes(colorName) ? 'remove' : 'add']('disabled');
        //clrEl.classList.remove("disabled")

        //console.log({activeColor, colorName})

        input.checked = activeColor == colorName;
    });
};

const possibleColors = [];
const allColors = [];

for (let g in allGroups) {
    const group = allGroups[g];
    for (let f in group.factures) {
        if (f == 'isDefault') continue;
        const facture = group.factures[f];
        for (let c in facture.collections) {
            if (c == 'isDefault') continue;
            const collection = facture.collections[c];
            for (let d in collection.depth) {
                if (d == 'isDefault') continue;
                const depth = collection.depth[d];
                for (let col in depth) {
                    if (col == 'default' || col == 'isDefault') continue;
                    const clrs = depth[col];
                    clrs.map((cl) => {
                        if (!possibleColors.includes(cl.colorName)) possibleColors.push(cl.colorName);

                        group.images.map((img) => {
                            const path = `./images/facades/${img.pathName}/${cl.colorName}.jpg`;
                            if (!allColors.includes(path)) allColors.push(path);
                        });
                    });
                }
            }
        }
    }
}

//console.log({possibleColors})
//console.log({allColors})

let infoWindowHTML = '';
allColors.map((colorPath) => {
    infoWindowHTML += `<img class="info-window__img " src="${colorPath}" alt="Предпросмотр" />`;
});
infoWindowHTML += `<img class="info-window__img" src="./images/facades/undefined.jpg" alt="Предпросмотр" />`;

document.querySelectorAll('.info-window__img-block').forEach((block) => (block.innerHTML = infoWindowHTML));

export function reCreateGroupMenu(groupName) {
    document.querySelector('input[name="meters-per-square"]').value = '1';

    if (servObj.isInfoWindowHide !== undefined) document.querySelector('.info-window').style.display = 'block';

    if (servObj.isInfoWindowHide == true) {
        const event = new Event('pointerdown');
        document.querySelector('#info-toggler').dispatchEvent(event);
    }
    if (servObj.isInfoWindowHide == undefined) servObj.isInfoWindowHide = false;
    //servObj.isInfoWindowHide = true

    if (!activeGroupName || groupName) activeGroupName = groupName;

    if (groupName) {
        createColorsMenuByPossibleColorsOnce = false;
        activeTilePattern = null;
        activeFacture = null;
        activeCollection = null;
        activeDepth = null;
        activeColor = null;
    }
    if (!activeGroupName && servObj.savedData && servObj.savedData.tile.activeGroupName)
        activeGroupName = servObj.savedData.tile.activeGroupName;
    if (!activeTilePattern && servObj.savedData && servObj.savedData.tile.activeTilePattern)
        activeTilePattern = servObj.savedData.tile.activeTilePattern;
    if (!activeFacture && servObj.savedData && servObj.savedData.tile.activeFacture)
        activeFacture = servObj.savedData.tile.activeFacture;
    if (!activeCollection && servObj.savedData && servObj.savedData.tile.activeCollection)
        activeCollection = servObj.savedData.tile.activeCollection;
    if (!activeDepth && servObj.savedData && servObj.savedData.tile.activeDepth)
        activeDepth = servObj.savedData.tile.activeDepth;
    if (!activeColor && servObj.savedData && servObj.savedData.tile.activeColor)
        activeColor = servObj.savedData.tile.activeColor;

    const group = allGroups[activeGroupName];

    document.querySelector('#selected-collection').innerHTML = group.name;

    let optionTilePatternInnerText = '';

    group.images.map((image) => {
        if (!activeTilePattern && image.isDefault) activeTilePattern = image;

        //console.log("_________")
        //console.log(activeTilePattern.pathName == image.pathName, activeTilePattern.pathName, image.pathName)

        // console.log(activeFacture)
        // console.log(activeCollection)
        // console.log(activeDepth)
        // console.log(activeColor)
        // console.log(activeGroupName)

        let imagePath = `./images/facades/${image.pathName}/default.jpg`;
        //if(!image.pathName || image.pathName == "undefined") imagePath = `./images/facades/${image.pathName}.jpg`

        optionTilePatternInnerText += `
			<div class="content__item">
				<label for="paving-slabs__pattern_${image.pathName}">
					<input 
						type="radio" name="paving-slabs__pattern" 
						id="paving-slabs__pattern_${image.pathName}" 
						value="${image.pathName}" 
						${activeTilePattern.pathName == image.pathName && 'checked'}
					>

					<img src="${imagePath}" alt="Ёлочка" class="item__img">
					<p class="item__name">
						${image.name}
					</p>
				</label>
			</div>
		`;
    });

    // for (let key in group.imgs){
    // 	const image = group.imgs[key]
    // 	if(!activeTilePattern && image.isDefault) activeTilePattern = image

    // 	optionTilePatternInnerText += `
    // 		<div class="content__item">
    // 			<input
    // 			type="radio" name="paving-slabs__pattern"
    // 			id="paving-slabs__pattern_${key}"
    // 			value="${key}"
    // 			${activeTilePattern == image && "checked"}>
    // 			<label for="paving-slabs__pattern_${key}">
    // 				<img src="./images/${key}.jpg" alt="Ёлочка" class="item__img">
    // 				<div class="item__name">
    // 					${image.name}
    // 				</div>
    // 			</label>
    // 		</div>
    // 	`
    // 	// Предпросмотр
    // 	if(activeTilePattern == image){
    // 		document.querySelectorAll(".info-window__img-block .info-window__img").forEach(el => {
    // 			el.classList[el.src.includes(key) ? "add" : "remove"]("active")
    // 		})
    // 	}
    // }

    document.querySelector('#option-tile-pattern .option__content').innerHTML = optionTilePatternInnerText;

    // Facture
    let optionFactureInnerText = ``;

    for (let key in group.factures) {
        if (key == 'isDefault') continue;
        const facture = group.factures[key];
        if (!activeFacture && facture.isDefault) activeFacture = facture;
    }

    for (let key in group.factures) {
        if (key == 'isDefault') continue;
        const facture = group.factures[key];
        optionFactureInnerText += `<option value="${key}" ${facture.name == activeFacture.name && 'selected'}>${
            facture.name
        }</option>`;
    }

    document.querySelector('#facture').innerHTML = optionFactureInnerText;

    // Collection

    let optionCollectionInnerText = '';

    const collectionsByFacture = [];
    const possibleCollections = [];
    const possibleDepths = [];
    const possibleColors = [];
    //const repeatedColors = []

    // for (let g in allGroups){
    // 	const group = allGroups[g]
    for (let f in group.factures) {
        if (f == 'isDefault') continue;
        const facture = group.factures[f];
        for (let c in facture.collections) {
            if (c == 'isDefault') continue;
            const collection = facture.collections[c];
            const fc = possibleCollections.find((cl) => cl.name == collection.name);
            if (!fc) possibleCollections.push({ id: c, ...collection });
            for (let d in collection.depth) {
                if (d == 'isDefault') continue;
                const depth = collection.depth[d];
                if (!possibleDepths.includes(d)) possibleDepths.push(d);
                for (let col in depth) {
                    if (col == 'default' || col == 'isDefault') continue;
                    const clrs = depth[col];
                    clrs.map((cl) => {
                        if (!possibleColors.includes(cl.colorName)) {
                            possibleColors.push(cl.colorName);
                        } else {
                            const clr = possibleColors.find((_) => _ == cl);
                            //if(clr) repeatedColors.push(clr)
                        }
                    });
                }
            }
        }
    }
    //}

    //console.log({possibleColors})

    for (let key in activeFacture.collections) {
        if (key == 'isDefault') continue;
        const collection = activeFacture.collections[key];
        if (!activeCollection && collection.isDefault) activeCollection = collection;
        collectionsByFacture.push(collection);
    }

    possibleCollections.map((collection) => {
        const findedCollection = collectionsByFacture.find((_) => _.name == collection.name);
        optionCollectionInnerText += `
			<div class="list__item ${findedCollection ? '' : 'disabled'}">
				<input type="radio" name="paving-slabs__collection" 
				${activeCollection.name == collection.name && 'checked'}
					id="paving-slabs__collection_${collection.id}"
					value="${collection.id}">
				<label  for="paving-slabs__collection_${collection.id}">
					<p>${collection.name}</p>
				</label>
			</div>
		`;
    });

    document.querySelector('#option-collection .option__list').innerHTML = optionCollectionInnerText;

    // Depths

    let optionDepthInnerText = '';

    const depthsByCollection = [];

    //
    //
    // console.log({activeCollection})
    for (let key in activeCollection.depth) {
        if (key == 'isDefault') continue;
        const depth = activeCollection.depth[key];

        // console.log({activeDepth})
        // console.log({activeColor})
        // console.warn(depth)

        if (!activeDepth && depth.isDefault) activeDepth = key;
        if (!activeColor && depth.isDefault && depth.default) activeColor = depth.default;
        depthsByCollection.push(key);
    }

    possibleDepths.map((depth) => {
        const findedDepth = depthsByCollection.find((_) => _ == depth);

        optionDepthInnerText += `
			<div class="list__item ${findedDepth ? '' : 'disabled'}">
				<input type="radio" name="paving-slabs__thickness" 
				id="paving-slabs__thickness_${depth}" value = "${depth}"
				${activeDepth == findedDepth && 'checked'}

				>
				<label for="paving-slabs__thickness_${depth}">
					<p>${depth} мм</p>
				</label>
			</div>
		`;
    });

    document.querySelector('#option-depth .option__list').innerHTML = optionDepthInnerText;

    // Colors

    let optionColorsInnerText = '';

    const colorsByDepth = [];

    activeCollection.depth[activeDepth].colors.map((color) => {
        colorsByDepth.push(color.colorName);
    });

    ///////////
    if (!createColorsMenuByPossibleColorsOnce) createColorsMenuByPossibleColors(group, possibleColors);
    updateColorsMenu(colorsByDepth, activeColor);

    servObj.tile.isEmptyTexture = false;
    document.querySelectorAll('.info-window__img-block .info-window__img').forEach((el) => {
        el.classList[el.src.includes(activeColor) && el.src.includes(activeTilePattern.pathName) ? 'add' : 'remove'](
            'active'
        );
        // if(repeatedColors.includes(activeColor)){
        //     if(el.src.includes(activeColor) && el.src.includes(activeFacture.pathName) && el.src.includes(activeTilePattern.pathName)){
        //         window.servObj.isEmptyTexture = true
        //         el.classList.add('active');
        //     }else{

        //         el.classList.remove('active');
        //     }

        // }else{
        //     el.classList[el.src.includes(activeColor) && el.src.includes(activeTilePattern.pathName) ? 'add' : 'remove']('active');

        // }
    });
    let isHasActiveImage = false;
    document.querySelectorAll('.info-window__img-block .info-window__img').forEach((el) => {
        if (el.classList.contains('active')) isHasActiveImage = true;
    });

    if (!isHasActiveImage) {
        servObj.tile.isEmptyTexture = true;
        document.querySelector('.info-window img[src="./images/facades/undefined.jpg"]').classList.add('active');
    }

    servObj.tile.activeTilePattern = activeTilePattern;
    servObj.tile.activeFacture = activeFacture;
    servObj.tile.activeCollection = activeCollection;
    servObj.tile.activeDepth = activeDepth;
    servObj.tile.activeColor = activeColor;
    servObj.tile.activeGroupName = activeGroupName;

    //window.servObj.repeatedColors = repeatedColors // TODO: remove

    //document.querySelector('#option-color .content').innerHTML = optionColorsInnerText;

    calculatePrice();
    if (servObj.savedData) servObj.savedData = null;
    servObj.currentCount.setCount(1); // Reset count to 1 after re-creating the group menu
}

activeGroupName = servObj.tile.activeGroupName;
activeTilePattern = servObj.tile.activeTilePattern;
activeFacture = servObj.tile.activeFacture;
activeCollection = servObj.tile.activeCollection;
activeDepth = servObj.tile.activeDepth;
activeColor = servObj.tile.activeColor;
document.querySelector(`#paving-slabs__${activeGroupName}`).checked = true;

reCreateGroupMenu();
